import { combineReducers } from '@reduxjs/toolkit';

import persistedLocaleReducer from './persistedLocale/slice';

const persisted = combineReducers({
    persistedLocale: persistedLocaleReducer,
});

export default persisted;